import { combineReducers } from "@reduxjs/toolkit";
import userDetailsReducer from "./User/userDetailsSlice";
import hermesReducer from "./Hermes/hermesSlice";
import portProfileReducer from "./PortProfile/portProfileSlice";
import logisticsProfileReducer from "./LogisticsProfile/logisticsProfileSlice";
import companyProfileReducer from "./CompanyProfile/companyProfileSlice";
import tradeLanesProfileReducer from "./TradeLanesProfile/tradeLanesProfileSlice";
import shipmentDetailsSlice from "./Shipment/shipmentSlice";
import sidebarCountReducer from "./Sidebar/sidebarCountSlice";
import bookmarksSlice from "./Bookmark/bookmarksSlice";
import profileContactsSlice from "./ProfileContacts/profileContactsSlice";
import analyticsDashletConfigSlice from "./Analytics/analyticsDashletConfigSlice";

const rootReducer = combineReducers({
  hermes: hermesReducer, // NOT in persist whitelist — transient chat state
  userDetails: userDetailsReducer,
  portProfile: portProfileReducer,
  logisticsProfile: logisticsProfileReducer,
  companyProfile: companyProfileReducer,
  tradeLanesProfile: tradeLanesProfileReducer,
  shipmentDetails: shipmentDetailsSlice,
  sidebarCount: sidebarCountReducer,
  bookmarkDetails: bookmarksSlice,
  profileContactData: profileContactsSlice,
  analyticsDashletConfig: analyticsDashletConfigSlice,
});

export default rootReducer;
